var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5Faktoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fffcf5;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #bec6c6;\n      }\n\n      .cls-3 {\n        fill: #1d1d1b;\n      }\n\n      .cls-4 {\n        fill: #ffa900;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Deposit"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40,3v10h-2.43c-.79,0-.89.19-4.68,2.56-2.33,1.46-2.66,1.8-3.55,1.8-2.1,0-3.15-2.55-1.67-4.03l2.69-2.69c-5.21-5.21-14.17-2.26-15.26,5.01-1.78.65-2.98-.09-4.1-.65l4.38-8.77c.39-.78,1.11-1.35,1.96-1.57,6.4-1.59,6.42-1.66,7.4-1.66h15.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33,40.06v.94l-9.28,3.71c-.99.39-1.11.29-6.66.29-1.36,0-1.53-.27-7.37-3.6-.84-.48-1.24-.4-3.69-.4v-10h6.79c.79,0,1.56.23,2.22.67l6.3,4.2c1.3.86,1.34,2.75.23,3.66l7.58-2.34c1.93-.59,3.88.85,3.88,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1,29h3c1.1,0,2,.9,2,2v10c0,1.1-.9,2-2,2H1v-14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m40,1h3c1.1,0,2,.9,2,2v10c0,1.1-.9,2-2,2h-3V1h0Z",
    transform: "translate(85 16) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m4,44H1c-.55,0-1-.45-1-1v-14c0-.55.45-1,1-1h3c1.65,0,3,1.35,3,3v10c0,1.65-1.35,3-3,3Zm-2-2h2c.55,0,1-.45,1-1v-10c0-.55-.45-1-1-1h-2v12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m22.23,46h-5.17c-.88,0-1.74-.23-2.48-.67-5.79-3.3-5.67-3.33-6.38-3.33h-2.2c-.55,0-1-.45-1-1v-10c0-.55.45-1,1-1h6.79c.99,0,1.95.29,2.77.84l6.3,4.2c.98.65,1.51,1.75,1.46,2.89l5.5-1.7c2.58-.79,5.17,1.13,5.17,3.83v.94c0,.41-.25.78-.63.93-9.92,3.96-9.86,4.07-11.14,4.07Zm-15.23-6c1.25,0,2.1-.1,3.19.53,5.86,3.34,5.82,3.47,6.87,3.47,5.45,0,5.53.08,6.29-.22l8.65-3.46v-.26c0-1.36-1.32-2.31-2.59-1.91l-7.4,2.28c-1.05.79-2.48.88-3.63.23l-4.88-2.79c-.48-.27-.65-.89-.37-1.36.27-.48.89-.65,1.36-.37l4.88,2.79c.86.49,1.95-.11,1.95-1.13,0-.44-.21-.85-.57-1.09l-6.3-4.2c-.49-.33-1.07-.5-1.67-.5h-5.79v8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m45,16h-3c-1.65,0-3-1.35-3-3V3c0-1.65,1.35-3,3-3h3c.55,0,1,.45,1,1v14c0,.55-.45,1-1,1Zm-3-14c-.55,0-1,.45-1,1v10c0,.55.45,1,1,1h2V2h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m13.74,16.9c-1.34,0-2.12-.47-3.19-1.01-.49-.25-.69-.85-.45-1.34l4.38-8.77c.52-1.05,1.47-1.81,2.61-2.09,6.44-1.61,6.5-1.7,7.64-1.7h15.26c.55,0,1,.45,1,1v10c0,.55-.45,1-1,1s-1-.45-1-1V4c-15.45,0-14.63-.06-15.47.15l-5.94,1.49c-.57.14-1.04.52-1.3,1.05-4.24,8.48-3.99,7.85-3.89,7.9,1.33.67,2.92.27,3.78-.94l2.58-3.62c.41-.58,1.02-.99,1.71-1.17l3.29-.82c.53-.13,1.08.19,1.21.73.13.54-.19,1.08-.73,1.21-3.57.89-3.57.81-3.86,1.21l-2.58,3.62c-.97,1.36-2.49,2.1-4.06,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m24,26c-4.97,0-9-4.03-9-9,0-8.01,9.72-12,15.36-6.36l-2.69,2.69c-.92.92-.92,2.42,0,3.34.76.76,1.95.93,2.92.33l2.3-1.44c.85,5.72-3.53,10.44-8.89,10.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24,14c-.55,0-1-.45-1-1v-2c0-.55.45-1,1-1s1,.45,1,1v2c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25,22h-4c-.55,0-1-.45-1-1s.45-1,1-1h4c.55,0,1-.45,1-1s-.45-1-1-1h-2c-1.65,0-3-1.35-3-3s1.35-3,3-3h4c.55,0,1,.45,1,1s-.45,1-1,1h-4c-.55,0-1,.45-1,1s.45,1,1,1h2c1.65,0,3,1.35,3,3s-1.35,3-3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24,24c-.55,0-1-.45-1-1v-2c0-.55.45-1,1-1s1,.45,1,1v2c0,.55-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m29.34,18.37c-3,0-4.48-3.64-2.37-5.75l3.33-3.33c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41l-3.33,3.33c-.53.53-.53,1.4,0,1.93.45.45,1.14.53,1.69.19l5.92-3.7c.89-.55,1.34-.46,4.02-.46.29,0,1,.22,1,1,0,.55-.45,1-1,1h-2.43c-.4,0-.04-.15-6.45,3.85-.55.35-1.17.52-1.79.52Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Faktoring);
export default __webpack_public_path__ + "static/media/5-Faktoring.078f5dfa7f00e7377c08cb44be155017.svg";
export { ForwardRef as ReactComponent };